<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" v-loading="loading">
      <!-- 复查列表 strat -->
      <el-tab-pane label="基本信息列表" name="first">
        <div class="block">
          <el-button type="primary" @click="clicksearch">查询</el-button>
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="CreateTime" label="创建时间" width="300px"></el-table-column>
          <el-table-column prop="Name" label="姓名" width="200px"></el-table-column>
          <el-table-column prop="Sex" label="性别" width="200px"></el-table-column>
          <el-table-column prop="Age" label="年龄" width="200px"></el-table-column>
          <el-table-column prop="Phone" label="手机" width="300px"></el-table-column>
          <el-table-column prop="operation" label="操作">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickModify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 复查列表 end -->

      <el-tab-pane label="添加" name="four">
        <CustomerBasicInfoSub ref="SubVuefour" v-on:triggerFunc="BackToFirst"></CustomerBasicInfoSub>
      </el-tab-pane>

      <el-tab-pane label="修改" name="five" disabled>
        <CustomerBasicInfoSub ref="SubVuefive" v-on:triggerFunc="BackToFirst"></CustomerBasicInfoSub>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import CustomerBasicInfoSub from '@/componentsSubVue/CustomerBasicInfoSub.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    CustomerBasicInfoSub
  },
  data () {
    return {
      activeName: 'first',
      loading: false,
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      glassuserid: 0
    }
  },
  mounted () {
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetErp7ShiGuangJiBenXinXiNum()
      this.apiGetErp7ShiGuangJiBenXinXiList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetErp7ShiGuangJiBenXinXiNum()
      this.apiGetErp7ShiGuangJiBenXinXiList()
    },
    LoadData (id) {
      this.dataList = []
      this.dataListnum = 0
      this.glassuserid = id
      this.apiGetErp7ShiGuangJiBenXinXiNum()
      this.apiGetErp7ShiGuangJiBenXinXiList()
      this.$refs.SubVuefour.initData(this.glassuserid)
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetErp7ShiGuangJiBenXinXiList()
    },
    clickModify (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.editMode(row)
    },
    clickDelete (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelErp7ShiGuangJiBenXinXi(row.Id)
      })
    },
    apiGetErp7ShiGuangJiBenXinXiList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.glassuserid,
        pageno: that.selectedPageNo
      }
      console.log(data)
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp7ShiGuangJiBenXinXiList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetErp7ShiGuangJiBenXinXiNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.glassuserid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp7ShiGuangJiBenXinXiNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelErp7ShiGuangJiBenXinXi: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelErp7ShiGuangJiBenXinXi, Qs.stringify(data))
        .then(function (response) {
          that.apiGetErp7ShiGuangJiBenXinXiNum()
          that.apiGetErp7ShiGuangJiBenXinXiList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
